import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { Link, Main } from 'components/layout';

const Container = ({ title, children, loading, ...rest }) => {
  return (
    <Main style={{ marginTop: '8px' }}>
      <PageContainer
        loading={loading}
        header={{
          title,
          breadcrumb: (
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/other-reports">Other Reports</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
          ),
        }}
        ghost
        {...rest}
      >
        {children}
      </PageContainer>
    </Main>
  );
};

Container.defaultProps = {
  title: '',
  loading: true,
};

Container.propTypes = {
  loading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default Container;
